import * as React from "react";
import moment from "moment";
import { ThumbnailCarousel } from "../";
import { Media } from "@/interfaces";
import { Button } from "@/components/ui";
import { textWithLimit } from "@/utils";

interface Props {
  title: string;
  message: string;
  hashtags?: string;
  showAttached?: boolean;
  showShortLink?: boolean;
  showComplianceDisclaimer?: boolean;
  media: Media[];
}

const PromptPreviewSection: React.FC<Props> = ({
  title,
  message,
  hashtags,
  showAttached = true,
  showShortLink = true,
  showComplianceDisclaimer = true,
  media,
}) => {
  return (
    <div className="flex flex-col gap-4 scale-90 sm:scale-100 origin-top">
      <div className="text-sm font-semibold w-full text-center text-slate-500">Example</div>

      {/* Phone Frame */}
      <div className="relative mx-auto border-slate-950 bg-slate-950 border-10 rounded-[3rem] h-[650px] w-[325px] shadow-2xl overflow-visible">
        {/* Top Speaker/Notch Area */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-4 bg-slate-950 rounded-b-2xl z-20 flex items-center justify-center">
          <div className="w-10 h-1 bg-slate-800 rounded-full mb-1"></div>
        </div>

        {/* Side Buttons (Visual details) */}
        <div className="absolute -left-[13px] top-24 w-[3px] h-12 bg-slate-900 rounded-l-lg border-l border-slate-800"></div>
        <div className="absolute -left-[13px] top-40 w-[3px] h-12 bg-slate-900 rounded-l-lg border-l border-slate-800"></div>
        <div className="absolute -right-[13px] top-32 w-[3px] h-16 bg-slate-900 rounded-r-lg border-r border-slate-800"></div>

        {/* Inner Screen */}
        <div className="previewContent relative bg-white h-full w-full overflow-y-auto no-scrollbar flex flex-col rounded-[2.2rem]">
          <div className="flex flex-col justify-center items-center px-4 pt-6 pb-3 gap-6 border-b border-slate-200">
            <div className="text-[16px] font-bold text-slate-900 leading-snug wrap-break-word">Prompt Details</div>
          </div>
          <div className="flex flex-col px-4 py-2 gap-6">
            <div className="text-[14px] font-semibold text-slate-900 leading-snug wrap-break-word">{title}</div>
          </div>
          {showAttached && media.length > 0 && (
            <div className="my-2 rounded-lg bg-white mx-4">
              <ThumbnailCarousel media={media} />
            </div>
          )}

          {/* Content Body */}
          <div className="p-4 flex flex-col gap-2 border border-slate-200 rounded-lg mx-4">
            <div className="flex flex-col gap-2 text-[12px] text-slate-700 leading-relaxed wrap-break-word">
              <div>{textWithLimit(message, 200)}</div>

              {showShortLink && (
                <div className="text-blue-600 break-all underline decoration-blue-300 underline-offset-2 cursor-pointer">
                  https://myoc.io/example-short-link
                </div>
              )}

              {hashtags && <div className="text-blue-600 break-all">{textWithLimit(hashtags, 80)}</div>}

              {showComplianceDisclaimer && <div>Example Disclaimer...</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PromptPreview = PromptPreviewSection;
